import { guidEmpty } from "utils/guid-empty";

export class MovBoletoResponseModel {
    constructor(
        public urlImpressao: string = '',
        public codigoBarras: string = '',
        public linhaDigitavel: string = '',
    ) { }
}

export class MovPixResponseModel {
    constructor(
        public pixCopiaCola: string = '',
    ) { }
}

export class MovErroResponseModel {
    constructor(
        public codigo: string = '',
        public mensagem: string = '',
    ) { }
}

export class MovParcelaResponseModel {
    constructor(
        public id: string = guidEmpty(),
        public nroParcela: number = 0,
        public dataRegistro: string = '',
        public dataExpiracao: string = '',
        public boleto: MovBoletoResponseModel = new MovBoletoResponseModel(),
        public pix: MovPixResponseModel = new MovPixResponseModel(),
        public erro: MovErroResponseModel = new MovErroResponseModel(),

    ) { }
}

export class MovRegistrarResponseModel {
    constructor(
        public parcelas: MovParcelaResponseModel[] = [],
    ) { }
}